<template>
  <div class="error">
    <div class="error__block">
      <h1 class="error__block-title">404</h1>
      <p class="error__block-text">{{ $t("common.notFoundPage") }}</p>
      <PrimaryButton @click="$router.push({ name: 'home' })">
        {{ $t("common.goToExhib") }}
      </PrimaryButton>
    </div>
  </div>
</template>

<script>
import { PrimaryButton } from "@v2/shared/ui/components";

export default {
  components: { PrimaryButton }
};
</script>

<style lang="scss" scoped>
.error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 120px);

  background-color: transparent;

  &__block {
    display: flex;
    flex-direction: column;
    align-items: center;
    &-title {
      color: #005197;
      font-size: 100px;
      margin: 0 0 33px 0;
    }

    &-text {
      font-size: 16px;
      font-weight: 500;
      line-height: 1.5;
      text-align: center;
      color: #505050;
      margin: 0 0 56px 0;
    }
  }
}
</style>
